webpackJsonp([32],{

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/lib/api.js
// export const CORE_API_ENDPOINT = 'https://www.rmbainisys.com/vms'
// export const CORE_API_ENDPOINT = `https://dtacbainisys.com/core`
// http://localhost:2000
// http://10.0.30.19:1000/vms
//https://profilecenter.rmbainisys.com/api

// export const CORE_API_ENDPOINT = 'http://localhost:2001'
// export const CORE_API_ENDPOINT = 'https://profilecenter.rmbainisys.com/api'

//10.0.30.9
var CORE_API_ENDPOINT = '/api';
// EXTERNAL MODULE: ./node_modules/base-64/base64.js
var base64 = __webpack_require__(226);
var base64_default = /*#__PURE__*/__webpack_require__.n(base64);

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(248);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// CONCATENATED MODULE: ./src/lib/auth.js
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var TOKEN = 'token';
var TOKEN_EXPIRES = 'token_expires';
var USER = 'user';
// const LANGUAGE = 'language'

function getCookie(key) {
    var value = js_cookie_default.a.get(key);
    var setValue = '';
    if (typeof value === 'string') {
        setValue = base64_default.a.decode(value);
    }
    return setValue;
}

function setCookie(key, value) {
    var valueToString = String(value);
    var setValue = '';
    if (typeof valueToString === 'string') {
        setValue = base64_default.a.encode(valueToString);
    }
    js_cookie_default.a.set(key, setValue);
}

function removeCookie(key) {
    js_cookie_default.a.remove(key);
}

function setToken(props) {
    clearToken();
    var token = props.token,
        expires = props.expires,
        user = props.user;


    if (typeof token !== "undefined") setCookie(TOKEN, token);
    if (typeof expires !== "undefined") setCookie(TOKEN_EXPIRES, expires);
    if (typeof user !== "undefined") setCookie(USER, user);
}

function clearToken() {
    removeCookie(TOKEN);
    removeCookie(TOKEN_EXPIRES);
    removeCookie(USER);
}

function getAllCookies() {
    var _ref;

    if (!getCookie(TOKEN)) return {};
    return _ref = {}, _defineProperty(_ref, TOKEN, getCookie(TOKEN)), _defineProperty(_ref, TOKEN_EXPIRES, getCookie(TOKEN_EXPIRES)), _defineProperty(_ref, USER, getCookie(USER)), _ref;
}

function getToken() {
    return getCookie(TOKEN);
}

function getLanguage() {
    return 'EN';
    // return getCookie(LANGUAGE)
}
// CONCATENATED MODULE: ./src/lib/setting.js
var timeZone = 'Asia/Bangkok';
var timeFormat = 'YYYY-MM-DDTHH:mm:ss';
var fullDateTimeFormat = 'YYYY-MM-DDTHH:mm:ss';
var displayDate = 'DD-MMM-YYYY';
var displayDateTime = 'DD-MMM-YYYY HH:mm';
// CONCATENATED MODULE: ./src/lib/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return CORE_API_ENDPOINT; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return setToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return clearToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return getAllCookies; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return getToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return getLanguage; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return timeZone; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return timeFormat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return fullDateTimeFormat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return displayDate; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return displayDateTime; });




/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LOGOUT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_129", function() { return SET_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_128", function() { return REQUEST_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_126", function() { return CORE_USER_VERIFY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_127", function() { return CORE_USER_VERIFY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_125", function() { return CORE_USER_VERIFY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_123", function() { return CORE_USER_LOGOUT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_124", function() { return CORE_USER_LOGOUT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_122", function() { return CORE_USER_LOGOUT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return CORE_LOAD_ALL_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return CORE_LOAD_ALL_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return CORE_LOAD_ALL_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return CORE_LOAD_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return CORE_LOAD_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return CORE_LOAD_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return CORE_DELETE_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return CORE_DELETE_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return CORE_DELETE_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CORE_CREATE_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CORE_CREATE_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CORE_CREATE_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_114", function() { return CORE_UPDATE_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_115", function() { return CORE_UPDATE_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return CORE_UPDATE_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return CORE_LOAD_ALL_CUSTOMER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return CORE_LOAD_ALL_CUSTOMER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return CORE_LOAD_ALL_CUSTOMER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return CORE_LOAD_CUSTOMER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return CORE_LOAD_CUSTOMER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return CORE_LOAD_CUSTOMER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CORE_DELETE_CUSTOMER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CORE_DELETE_CUSTOMER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CORE_DELETE_CUSTOMER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CORE_CREATE_CUSTOMER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CORE_CREATE_CUSTOMER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CORE_CREATE_CUSTOMER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return CORE_UPDATE_CUSTOMER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return CORE_UPDATE_CUSTOMER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return CORE_UPDATE_CUSTOMER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return CORE_LOAD_ALL_CONTACT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return CORE_LOAD_ALL_CONTACT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return CORE_LOAD_ALL_CONTACT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return CORE_LOAD_SEARCH_CONTACT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return CORE_LOAD_SEARCH_CONTACT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return CORE_LOAD_SEARCH_CONTACT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return CORE_LOAD_CONTACT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return CORE_LOAD_CONTACT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return CORE_LOAD_CONTACT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CORE_DELETE_CONTACT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CORE_DELETE_CONTACT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CORE_DELETE_CONTACT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CORE_CREATE_CONTACT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CORE_CREATE_CONTACT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CORE_CREATE_CONTACT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return CORE_UPDATE_CONTACT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return CORE_UPDATE_CONTACT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return CORE_UPDATE_CONTACT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return CORE_LOAD_ALL_PROFILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return CORE_LOAD_ALL_PROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return CORE_LOAD_ALL_PROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return CORE_LOAD_PROFILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return CORE_LOAD_PROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return CORE_LOAD_PROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return CORE_DELETE_PROFILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return CORE_DELETE_PROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return CORE_DELETE_PROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CORE_CREATE_PROFILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CORE_CREATE_PROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CORE_CREATE_PROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return CORE_UPDATE_PROFILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return CORE_UPDATE_PROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return CORE_UPDATE_PROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return CORE_LOAD_ALL_PRODUCT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return CORE_LOAD_ALL_PRODUCT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return CORE_LOAD_ALL_PRODUCT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return CORE_LOAD_PRODUCT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return CORE_LOAD_PRODUCT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return CORE_LOAD_PRODUCT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return CORE_DELETE_PRODUCT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return CORE_DELETE_PRODUCT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return CORE_DELETE_PRODUCT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CORE_CREATE_PRODUCT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CORE_CREATE_PRODUCT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CORE_CREATE_PRODUCT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return CORE_UPDATE_PRODUCT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return CORE_UPDATE_PRODUCT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return CORE_UPDATE_PRODUCT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_120", function() { return CORE_UPVERSION_PRODUCT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_121", function() { return CORE_UPVERSION_PRODUCT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_119", function() { return CORE_UPVERSION_PRODUCT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return CORE_LOAD_ALL_VERSION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return CORE_LOAD_ALL_VERSION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return CORE_LOAD_ALL_VERSION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return CORE_LOAD_VERSION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return CORE_LOAD_VERSION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return CORE_LOAD_VERSION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return CORE_DELETE_VERSION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return CORE_DELETE_VERSION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return CORE_DELETE_VERSION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CORE_CREATE_VERSION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CORE_CREATE_VERSION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CORE_CREATE_VERSION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_117", function() { return CORE_UPDATE_VERSION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_118", function() { return CORE_UPDATE_VERSION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_116", function() { return CORE_UPDATE_VERSION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return CORE_LOAD_ALL_DEVICE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return CORE_LOAD_ALL_DEVICE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return CORE_LOAD_ALL_DEVICE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return CORE_LOAD_DEVICE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return CORE_LOAD_DEVICE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return CORE_LOAD_DEVICE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CORE_DELETE_DEVICE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CORE_DELETE_DEVICE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CORE_DELETE_DEVICE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CORE_CREATE_DEVICE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CORE_CREATE_DEVICE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CORE_CREATE_DEVICE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return CORE_UPDATE_DEVICE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return CORE_UPDATE_DEVICE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return CORE_UPDATE_DEVICE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return CORE_LOAD_ALL_LICENSETYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return CORE_LOAD_ALL_LICENSETYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return CORE_LOAD_ALL_LICENSETYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return CORE_LOAD_LICENSETYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return CORE_LOAD_LICENSETYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return CORE_LOAD_LICENSETYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return CORE_LOAD_ALL_LICENSE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return CORE_LOAD_ALL_LICENSE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return CORE_LOAD_ALL_LICENSE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return CORE_LOAD_ALL_LICENSE_DISPLAY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return CORE_LOAD_ALL_LICENSE_DISPLAY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return CORE_LOAD_ALL_LICENSE_DISPLAY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return CORE_LOAD_ALL_LICENSE_IOT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return CORE_LOAD_ALL_LICENSE_IOT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return CORE_LOAD_ALL_LICENSE_IOT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return CORE_LOAD_LICENSE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return CORE_LOAD_LICENSE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return CORE_LOAD_LICENSE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return CORE_DELETE_LICENSE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return CORE_DELETE_LICENSE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return CORE_DELETE_LICENSE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CORE_CREATE_LICENSE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CORE_CREATE_LICENSE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CORE_CREATE_LICENSE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return CORE_UPDATE_LICENSE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return CORE_UPDATE_LICENSE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return CORE_UPDATE_LICENSE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return CORE_UNREGISTER_LICENSE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return CORE_UNREGISTER_LICENSE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return CORE_UNREGISTER_LICENSE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return CORE_LOAD_ALL_IOTACCESSORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return CORE_LOAD_ALL_IOTACCESSORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return CORE_LOAD_ALL_IOTACCESSORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return CORE_LOAD_IOTACCESSORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return CORE_LOAD_IOTACCESSORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return CORE_LOAD_IOTACCESSORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CORE_DELETE_IOTACCESSORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CORE_DELETE_IOTACCESSORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CORE_DELETE_IOTACCESSORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CORE_CREATE_IOTACCESSORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CORE_CREATE_IOTACCESSORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CORE_CREATE_IOTACCESSORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return CORE_UPDATE_IOTACCESSORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return CORE_UPDATE_IOTACCESSORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return CORE_UPDATE_IOTACCESSORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return CORE_LOAD_ALL_IOTROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return CORE_LOAD_ALL_IOTROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return CORE_LOAD_ALL_IOTROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return CORE_LOAD_IOTROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return CORE_LOAD_IOTROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return CORE_LOAD_IOTROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return CORE_DELETE_IOTROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return CORE_DELETE_IOTROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return CORE_DELETE_IOTROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CORE_CREATE_IOTROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CORE_CREATE_IOTROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CORE_CREATE_IOTROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return CORE_UPDATE_IOTROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return CORE_UPDATE_IOTROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return CORE_UPDATE_IOTROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return CORE_UNREGISTER_IOTROOM_LICENSE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return CORE_UNREGISTER_IOTROOM_LICENSE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return CORE_UNREGISTER_IOTROOM_LICENSE_FAILURE; });
var LOGOUT = 'LOGOUT';

var SET_ERROR = 'SET_ERROR';
var REQUEST_STATE = 'REQUEST_STATE';

//USER
var CORE_USER_VERIFY_REQUEST = 'CORE_USER_VERIFY_REQUEST';
var CORE_USER_VERIFY_SUCCESS = 'CORE_USER_VERIFY_SUCCESS';
var CORE_USER_VERIFY_FAILURE = 'CORE_USER_VERIFY_FAILURE';

var CORE_USER_LOGOUT_REQUEST = 'CORE_USER_LOGOUT_REQUEST';
var CORE_USER_LOGOUT_SUCCESS = 'CORE_USER_LOGOUT_SUCCESS';
var CORE_USER_LOGOUT_FAILURE = 'CORE_USER_LOGOUT_FAILURE';

var CORE_LOAD_ALL_USER_REQUEST = 'CORE_LOAD_ALL_USER_REQUEST';
var CORE_LOAD_ALL_USER_SUCCESS = 'CORE_LOAD_ALL_USER_SUCCESS';
var CORE_LOAD_ALL_USER_FAILURE = 'CORE_LOAD_ALL_USER_FAILURE';

var CORE_LOAD_USER_REQUEST = 'CORE_LOAD_USER_REQUEST';
var CORE_LOAD_USER_SUCCESS = 'CORE_LOAD_USER_SUCCESS';
var CORE_LOAD_USER_FAILURE = 'CORE_LOAD_USER_FAILURE';

var CORE_DELETE_USER_REQUEST = 'CORE_DELETE_USER_REQUEST';
var CORE_DELETE_USER_SUCCESS = 'CORE_DELETE_USER_SUCCESS';
var CORE_DELETE_USER_FAILURE = 'CORE_DELETE_USER_FAILURE';

var CORE_CREATE_USER_REQUEST = 'CORE_CREATE_USER_REQUEST';
var CORE_CREATE_USER_SUCCESS = 'CORE_CREATE_USER_SUCCESS';
var CORE_CREATE_USER_FAILURE = 'CORE_CREATE_USER_FAILURE';

var CORE_UPDATE_USER_REQUEST = 'CORE_UPDATE_USER_REQUEST';
var CORE_UPDATE_USER_SUCCESS = 'CORE_UPDATE_USER_SUCCESS';
var CORE_UPDATE_USER_FAILURE = 'CORE_UPDATE_USER_FAILURE';

//CUSTOMER
var CORE_LOAD_ALL_CUSTOMER_REQUEST = 'CORE_LOAD_ALL_CUSTOMER_REQUEST';
var CORE_LOAD_ALL_CUSTOMER_SUCCESS = 'CORE_LOAD_ALL_CUSTOMER_SUCCESS';
var CORE_LOAD_ALL_CUSTOMER_FAILURE = 'CORE_LOAD_ALL_CUSTOMER_FAILURE';

var CORE_LOAD_CUSTOMER_REQUEST = 'CORE_LOAD_CUSTOMER_REQUEST';
var CORE_LOAD_CUSTOMER_SUCCESS = 'CORE_LOAD_CUSTOMER_SUCCESS';
var CORE_LOAD_CUSTOMER_FAILURE = 'CORE_LOAD_CUSTOMER_FAILURE';

var CORE_DELETE_CUSTOMER_REQUEST = 'CORE_DELETE_CUSTOMER_REQUEST';
var CORE_DELETE_CUSTOMER_SUCCESS = 'CORE_DELETE_CUSTOMER_SUCCESS';
var CORE_DELETE_CUSTOMER_FAILURE = 'CORE_DELETE_CUSTOMER_FAILURE';

var CORE_CREATE_CUSTOMER_REQUEST = 'CORE_CREATE_CUSTOMER_REQUEST';
var CORE_CREATE_CUSTOMER_SUCCESS = 'CORE_CREATE_CUSTOMER_SUCCESS';
var CORE_CREATE_CUSTOMER_FAILURE = 'CORE_CREATE_CUSTOMER_FAILURE';

var CORE_UPDATE_CUSTOMER_REQUEST = 'CORE_UPDATE_CUSTOMER_REQUEST';
var CORE_UPDATE_CUSTOMER_SUCCESS = 'CORE_UPDATE_CUSTOMER_SUCCESS';
var CORE_UPDATE_CUSTOMER_FAILURE = 'CORE_UPDATE_CUSTOMER_FAILURE';

//CONTACT
var CORE_LOAD_ALL_CONTACT_REQUEST = 'CORE_LOAD_ALL_CONTACT_REQUEST';
var CORE_LOAD_ALL_CONTACT_SUCCESS = 'CORE_LOAD_ALL_CONTACT_SUCCESS';
var CORE_LOAD_ALL_CONTACT_FAILURE = 'CORE_LOAD_ALL_CONTACT_FAILURE';

var CORE_LOAD_SEARCH_CONTACT_REQUEST = 'CORE_LOAD_SEARCH_CONTACT_REQUEST';
var CORE_LOAD_SEARCH_CONTACT_SUCCESS = 'CORE_LOAD_SEARCH_CONTACT_SUCCESS';
var CORE_LOAD_SEARCH_CONTACT_FAILURE = 'CORE_LOAD_SEARCH_CONTACT_FAILURE';

var CORE_LOAD_CONTACT_REQUEST = 'CORE_LOAD_CONTACT_REQUEST';
var CORE_LOAD_CONTACT_SUCCESS = 'CORE_LOAD_CONTACT_SUCCESS';
var CORE_LOAD_CONTACT_FAILURE = 'CORE_LOAD_CONTACT_FAILURE';

var CORE_DELETE_CONTACT_REQUEST = 'CORE_DELETE_CONTACT_REQUEST';
var CORE_DELETE_CONTACT_SUCCESS = 'CORE_DELETE_CONTACT_SUCCESS';
var CORE_DELETE_CONTACT_FAILURE = 'CORE_DELETE_CONTACT_FAILURE';

var CORE_CREATE_CONTACT_REQUEST = 'CORE_CREATE_CONTACT_REQUEST';
var CORE_CREATE_CONTACT_SUCCESS = 'CORE_CREATE_CONTACT_SUCCESS';
var CORE_CREATE_CONTACT_FAILURE = 'CORE_CREATE_CONTACT_FAILURE';

var CORE_UPDATE_CONTACT_REQUEST = 'CORE_UPDATE_CONTACT_REQUEST';
var CORE_UPDATE_CONTACT_SUCCESS = 'CORE_UPDATE_CONTACT_SUCCESS';
var CORE_UPDATE_CONTACT_FAILURE = 'CORE_UPDATE_CONTACT_FAILURE';

//PROFILE
var CORE_LOAD_ALL_PROFILE_REQUEST = 'CORE_LOAD_ALL_PROFILE_REQUEST';
var CORE_LOAD_ALL_PROFILE_SUCCESS = 'CORE_LOAD_ALL_PROFILE_SUCCESS';
var CORE_LOAD_ALL_PROFILE_FAILURE = 'CORE_LOAD_ALL_PROFILE_FAILURE';

var CORE_LOAD_PROFILE_REQUEST = 'CORE_LOAD_PROFILE_REQUEST';
var CORE_LOAD_PROFILE_SUCCESS = 'CORE_LOAD_PROFILE_SUCCESS';
var CORE_LOAD_PROFILE_FAILURE = 'CORE_LOAD_PROFILE_FAILURE';

var CORE_DELETE_PROFILE_REQUEST = 'CORE_DELETE_PROFILE_REQUEST';
var CORE_DELETE_PROFILE_SUCCESS = 'CORE_DELETE_PROFILE_SUCCESS';
var CORE_DELETE_PROFILE_FAILURE = 'CORE_DELETE_PROFILE_FAILURE';

var CORE_CREATE_PROFILE_REQUEST = 'CORE_CREATE_PROFILE_REQUEST';
var CORE_CREATE_PROFILE_SUCCESS = 'CORE_CREATE_PROFILE_SUCCESS';
var CORE_CREATE_PROFILE_FAILURE = 'CORE_CREATE_PROFILE_FAILURE';

var CORE_UPDATE_PROFILE_REQUEST = 'CORE_UPDATE_PROFILE_REQUEST';
var CORE_UPDATE_PROFILE_SUCCESS = 'CORE_UPDATE_PROFILE_SUCCESS';
var CORE_UPDATE_PROFILE_FAILURE = 'CORE_UPDATE_PROFILE_FAILURE';

//PRODUCT
var CORE_LOAD_ALL_PRODUCT_REQUEST = 'CORE_LOAD_ALL_PRODUCT_REQUEST';
var CORE_LOAD_ALL_PRODUCT_SUCCESS = 'CORE_LOAD_ALL_PRODUCT_SUCCESS';
var CORE_LOAD_ALL_PRODUCT_FAILURE = 'CORE_LOAD_ALL_PRODUCT_FAILURE';

var CORE_LOAD_PRODUCT_REQUEST = 'CORE_LOAD_PRODUCT_REQUEST';
var CORE_LOAD_PRODUCT_SUCCESS = 'CORE_LOAD_PRODUCT_SUCCESS';
var CORE_LOAD_PRODUCT_FAILURE = 'CORE_LOAD_PRODUCT_FAILURE';

var CORE_DELETE_PRODUCT_REQUEST = 'CORE_DELETE_PRODUCT_REQUEST';
var CORE_DELETE_PRODUCT_SUCCESS = 'CORE_DELETE_PRODUCT_SUCCESS';
var CORE_DELETE_PRODUCT_FAILURE = 'CORE_DELETE_PRODUCT_FAILURE';

var CORE_CREATE_PRODUCT_REQUEST = 'CORE_CREATE_PRODUCT_REQUEST';
var CORE_CREATE_PRODUCT_SUCCESS = 'CORE_CREATE_PRODUCT_SUCCESS';
var CORE_CREATE_PRODUCT_FAILURE = 'CORE_CREATE_PRODUCT_FAILURE';

var CORE_UPDATE_PRODUCT_REQUEST = 'CORE_UPDATE_PRODUCT_REQUEST';
var CORE_UPDATE_PRODUCT_SUCCESS = 'CORE_UPDATE_PRODUCT_SUCCESS';
var CORE_UPDATE_PRODUCT_FAILURE = 'CORE_UPDATE_PRODUCT_FAILURE';

var CORE_UPVERSION_PRODUCT_REQUEST = 'CORE_UPVERSION_PRODUCT_REQUEST';
var CORE_UPVERSION_PRODUCT_SUCCESS = 'CORE_UPVERSION_PRODUCT_SUCCESS';
var CORE_UPVERSION_PRODUCT_FAILURE = 'CORE_UPVERSION_PRODUCT_FAILURE';

//VERSION
var CORE_LOAD_ALL_VERSION_REQUEST = 'CORE_LOAD_ALL_VERSION_REQUEST';
var CORE_LOAD_ALL_VERSION_SUCCESS = 'CORE_LOAD_ALL_VERSION_SUCCESS';
var CORE_LOAD_ALL_VERSION_FAILURE = 'CORE_LOAD_ALL_VERSION_FAILURE';

var CORE_LOAD_VERSION_REQUEST = 'CORE_LOAD_VERSION_REQUEST';
var CORE_LOAD_VERSION_SUCCESS = 'CORE_LOAD_VERSION_SUCCESS';
var CORE_LOAD_VERSION_FAILURE = 'CORE_LOAD_VERSION_FAILURE';

var CORE_DELETE_VERSION_REQUEST = 'CORE_DELETE_VERSION_REQUEST';
var CORE_DELETE_VERSION_SUCCESS = 'CORE_DELETE_VERSION_SUCCESS';
var CORE_DELETE_VERSION_FAILURE = 'CORE_DELETE_VERSION_FAILURE';

var CORE_CREATE_VERSION_REQUEST = 'CORE_CREATE_VERSION_REQUEST';
var CORE_CREATE_VERSION_SUCCESS = 'CORE_CREATE_VERSION_SUCCESS';
var CORE_CREATE_VERSION_FAILURE = 'CORE_CREATE_VERSION_FAILURE';

var CORE_UPDATE_VERSION_REQUEST = 'CORE_UPDATE_VERSION_REQUEST';
var CORE_UPDATE_VERSION_SUCCESS = 'CORE_UPDATE_VERSION_SUCCESS';
var CORE_UPDATE_VERSION_FAILURE = 'CORE_UPDATE_VERSION_FAILURE';

//DEVICE
var CORE_LOAD_ALL_DEVICE_REQUEST = 'CORE_LOAD_ALL_DEVICE_REQUEST';
var CORE_LOAD_ALL_DEVICE_SUCCESS = 'CORE_LOAD_ALL_DEVICE_SUCCESS';
var CORE_LOAD_ALL_DEVICE_FAILURE = 'CORE_LOAD_ALL_DEVICE_FAILURE';

var CORE_LOAD_DEVICE_REQUEST = 'CORE_LOAD_DEVICE_REQUEST';
var CORE_LOAD_DEVICE_SUCCESS = 'CORE_LOAD_DEVICE_SUCCESS';
var CORE_LOAD_DEVICE_FAILURE = 'CORE_LOAD_DEVICE_FAILURE';

var CORE_DELETE_DEVICE_REQUEST = 'CORE_DELETE_DEVICE_REQUEST';
var CORE_DELETE_DEVICE_SUCCESS = 'CORE_DELETE_DEVICE_SUCCESS';
var CORE_DELETE_DEVICE_FAILURE = 'CORE_DELETE_DEVICE_FAILURE';

var CORE_CREATE_DEVICE_REQUEST = 'CORE_CREATE_DEVICE_REQUEST';
var CORE_CREATE_DEVICE_SUCCESS = 'CORE_CREATE_DEVICE_SUCCESS';
var CORE_CREATE_DEVICE_FAILURE = 'CORE_CREATE_DEVICE_FAILURE';

var CORE_UPDATE_DEVICE_REQUEST = 'CORE_UPDATE_DEVICE_REQUEST';
var CORE_UPDATE_DEVICE_SUCCESS = 'CORE_UPDATE_DEVICE_SUCCESS';
var CORE_UPDATE_DEVICE_FAILURE = 'CORE_UPDATE_DEVICE_FAILURE';

//LICENSETYPE
var CORE_LOAD_ALL_LICENSETYPE_REQUEST = 'CORE_LOAD_ALL_LICENSETYPE_REQUEST';
var CORE_LOAD_ALL_LICENSETYPE_SUCCESS = 'CORE_LOAD_ALL_LICENSETYPE_SUCCESS';
var CORE_LOAD_ALL_LICENSETYPE_FAILURE = 'CORE_LOAD_ALL_LICENSETYPE_FAILURE';

var CORE_LOAD_LICENSETYPE_REQUEST = 'CORE_LOAD_LICENSETYPE_REQUEST';
var CORE_LOAD_LICENSETYPE_SUCCESS = 'CORE_LOAD_LICENSETYPE_SUCCESS';
var CORE_LOAD_LICENSETYPE_FAILURE = 'CORE_LOAD_LICENSETYPE_FAILURE';

//LICENSE
var CORE_LOAD_ALL_LICENSE_REQUEST = 'CORE_LOAD_ALL_LICENSE_REQUEST';
var CORE_LOAD_ALL_LICENSE_SUCCESS = 'CORE_LOAD_ALL_LICENSE_SUCCESS';
var CORE_LOAD_ALL_LICENSE_FAILURE = 'CORE_LOAD_ALL_LICENSE_FAILURE';

var CORE_LOAD_ALL_LICENSE_DISPLAY_REQUEST = 'CORE_LOAD_ALL_LICENSE_DISPLAY_REQUEST';
var CORE_LOAD_ALL_LICENSE_DISPLAY_SUCCESS = 'CORE_LOAD_ALL_LICENSE_DISPLAY_SUCCESS';
var CORE_LOAD_ALL_LICENSE_DISPLAY_FAILURE = 'CORE_LOAD_ALL_LICENSE_DISPLAY_FAILURE';

var CORE_LOAD_ALL_LICENSE_IOT_REQUEST = 'CORE_LOAD_ALL_LICENSE_IOT_REQUEST';
var CORE_LOAD_ALL_LICENSE_IOT_SUCCESS = 'CORE_LOAD_ALL_LICENSE_IOT_SUCCESS';
var CORE_LOAD_ALL_LICENSE_IOT_FAILURE = 'CORE_LOAD_ALL_LICENSE_IOT_FAILURE';

var CORE_LOAD_LICENSE_REQUEST = 'CORE_LOAD_LICENSE_REQUEST';
var CORE_LOAD_LICENSE_SUCCESS = 'CORE_LOAD_LICENSE_SUCCESS';
var CORE_LOAD_LICENSE_FAILURE = 'CORE_LOAD_LICENSE_FAILURE';

var CORE_DELETE_LICENSE_REQUEST = 'CORE_DELETE_LICENSE_REQUEST';
var CORE_DELETE_LICENSE_SUCCESS = 'CORE_DELETE_LICENSE_SUCCESS';
var CORE_DELETE_LICENSE_FAILURE = 'CORE_DELETE_LICENSE_FAILURE';

var CORE_CREATE_LICENSE_REQUEST = 'CORE_CREATE_LICENSE_REQUEST';
var CORE_CREATE_LICENSE_SUCCESS = 'CORE_CREATE_LICENSE_SUCCESS';
var CORE_CREATE_LICENSE_FAILURE = 'CORE_CREATE_LICENSE_FAILURE';

var CORE_UPDATE_LICENSE_REQUEST = 'CORE_UPDATE_LICENSE_REQUEST';
var CORE_UPDATE_LICENSE_SUCCESS = 'CORE_UPDATE_LICENSE_SUCCESS';
var CORE_UPDATE_LICENSE_FAILURE = 'CORE_UPDATE_LICENSE_FAILURE';

var CORE_UNREGISTER_LICENSE_REQUEST = 'CORE_UNREGISTER_LICENSE_REQUEST';
var CORE_UNREGISTER_LICENSE_SUCCESS = 'CORE_UNREGISTER_LICENSE_SUCCESS';
var CORE_UNREGISTER_LICENSE_FAILURE = 'CORE_UNREGISTER_LICENSE_FAILURE';

//IOTACCESSORY
var CORE_LOAD_ALL_IOTACCESSORY_REQUEST = 'CORE_LOAD_ALL_IOTACCESSORY_REQUEST';
var CORE_LOAD_ALL_IOTACCESSORY_SUCCESS = 'CORE_LOAD_ALL_IOTACCESSORY_SUCCESS';
var CORE_LOAD_ALL_IOTACCESSORY_FAILURE = 'CORE_LOAD_ALL_IOTACCESSORY_FAILURE';

var CORE_LOAD_IOTACCESSORY_REQUEST = 'CORE_LOAD_IOTACCESSORY_REQUEST';
var CORE_LOAD_IOTACCESSORY_SUCCESS = 'CORE_LOAD_IOTACCESSORY_SUCCESS';
var CORE_LOAD_IOTACCESSORY_FAILURE = 'CORE_LOAD_IOTACCESSORY_FAILURE';

var CORE_DELETE_IOTACCESSORY_REQUEST = 'CORE_DELETE_IOTACCESSORY_REQUEST';
var CORE_DELETE_IOTACCESSORY_SUCCESS = 'CORE_DELETE_IOTACCESSORY_SUCCESS';
var CORE_DELETE_IOTACCESSORY_FAILURE = 'CORE_DELETE_IOTACCESSORY_FAILURE';

var CORE_CREATE_IOTACCESSORY_REQUEST = 'CORE_CREATE_IOTACCESSORY_REQUEST';
var CORE_CREATE_IOTACCESSORY_SUCCESS = 'CORE_CREATE_IOTACCESSORY_SUCCESS';
var CORE_CREATE_IOTACCESSORY_FAILURE = 'CORE_CREATE_IOTACCESSORY_FAILURE';

var CORE_UPDATE_IOTACCESSORY_REQUEST = 'CORE_UPDATE_IOTACCESSORY_REQUEST';
var CORE_UPDATE_IOTACCESSORY_SUCCESS = 'CORE_UPDATE_IOTACCESSORY_SUCCESS';
var CORE_UPDATE_IOTACCESSORY_FAILURE = 'CORE_UPDATE_IOTACCESSORY_FAILURE';

//IOTROOM
var CORE_LOAD_ALL_IOTROOM_REQUEST = 'CORE_LOAD_ALL_IOTROOM_REQUEST';
var CORE_LOAD_ALL_IOTROOM_SUCCESS = 'CORE_LOAD_ALL_IOTROOM_SUCCESS';
var CORE_LOAD_ALL_IOTROOM_FAILURE = 'CORE_LOAD_ALL_IOTROOM_FAILURE';

var CORE_LOAD_IOTROOM_REQUEST = 'CORE_LOAD_IOTROOM_REQUEST';
var CORE_LOAD_IOTROOM_SUCCESS = 'CORE_LOAD_IOTROOM_SUCCESS';
var CORE_LOAD_IOTROOM_FAILURE = 'CORE_LOAD_IOTROOM_FAILURE';

var CORE_DELETE_IOTROOM_REQUEST = 'CORE_DELETE_IOTROOM_REQUEST';
var CORE_DELETE_IOTROOM_SUCCESS = 'CORE_DELETE_IOTROOM_SUCCESS';
var CORE_DELETE_IOTROOM_FAILURE = 'CORE_DELETE_IOTROOM_FAILURE';

var CORE_CREATE_IOTROOM_REQUEST = 'CORE_CREATE_IOTROOM_REQUEST';
var CORE_CREATE_IOTROOM_SUCCESS = 'CORE_CREATE_IOTROOM_SUCCESS';
var CORE_CREATE_IOTROOM_FAILURE = 'CORE_CREATE_IOTROOM_FAILURE';

var CORE_UPDATE_IOTROOM_REQUEST = 'CORE_UPDATE_IOTROOM_REQUEST';
var CORE_UPDATE_IOTROOM_SUCCESS = 'CORE_UPDATE_IOTROOM_SUCCESS';
var CORE_UPDATE_IOTROOM_FAILURE = 'CORE_UPDATE_IOTROOM_FAILURE';

var CORE_UNREGISTER_IOTROOM_LICENSE_REQUEST = 'CORE_UNREGISTER_IOTROOM_LICENSE_REQUEST';
var CORE_UNREGISTER_IOTROOM_LICENSE_SUCCESS = 'CORE_UNREGISTER_IOTROOM_LICENSE_SUCCESS';
var CORE_UNREGISTER_IOTROOM_LICENSE_FAILURE = 'CORE_UNREGISTER_IOTROOM_LICENSE_FAILURE';

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/middlewares/api.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var CALL_API = Symbol('CALL_API');

var resStatusError = [400, 401, 402, 403, 404, 422, 500, 501, 502, 503];

function getAction(type, action, state, res) {
    return new Promise(function (resolve, reject) {
        if (!res) return resolve({ type: type });

        if (resStatusError.includes(res.status)) {
            res.json().then(function (json) {
                return reject(_extends({ statusText: res.statusText }, json));
            });
        }

        if ((typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'object') {
            if (type.payload) {
                var payload = type.payload(action, state, res);
                if (typeof payload.then === 'function') {
                    //promise
                    return payload.then(function (data) {
                        return resolve({ type: type.type, payload: data });
                    });
                } else {
                    return resolve({ type: type.type, payload: payload });
                }
            }

            return resolve({ type: type.type });
        }

        res.json().then(function (payload) {
            return resolve({ type: type, payload: payload });
        });
    });
}

/* harmony default export */ var api = (function (_ref) {
    var getState = _ref.getState;
    return function (next) {
        return function (action) {
            if (_typeof(action[CALL_API]) !== 'object') return next(action);

            var _action$CALL_API = action[CALL_API],
                endpoint = _action$CALL_API.endpoint,
                _action$CALL_API$meth = _action$CALL_API.method,
                method = _action$CALL_API$meth === undefined ? 'GET' : _action$CALL_API$meth,
                headers = _action$CALL_API.headers,
                body = _action$CALL_API.body,
                types = _action$CALL_API.types;

            var _types = _slicedToArray(types, 3),
                request = _types[0],
                success = _types[1],
                failure = _types[2];

            var callBack = success.callBack;

            var state = getState();

            getAction(request, action, state).then(function (action) {
                return next(action);
            });

            if (callBack) {
                fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
                    return getAction(success, action, state, res);
                }).then(function (action) {
                    return next(action);
                }).then(function () {
                    return callBack();
                }).catch(function (err) {
                    return next({ type: failure, payload: err, error: true });
                });
            } else {
                fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
                    return getAction(success, action, state, res);
                }).then(function (action) {
                    return next(action);
                }).catch(function (err) {
                    return next({ type: failure, payload: err, error: true });
                });
            }
        };
    };
});
// EXTERNAL MODULE: ./src/lib/index.js + 3 modules
var lib = __webpack_require__(119);

// CONCATENATED MODULE: ./src/middlewares/checkToken.js
var checkToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };


// import moment from 'moment-timezone'


/* harmony default export */ var checkToken = (function (store) {
    return function (next) {
        return function (action) {
            var entry = action[CALL_API];

            if ((typeof entry === 'undefined' ? 'undefined' : checkToken__typeof(entry)) !== 'object') return next(action);

            var isCORE = entry.types[0].startsWith("CORE");

            if (isCORE) {
                var token = Object(lib["h" /* getToken */])();
                if (!token) return next(action);else next(action);

                // const { expires_on, access_token } = getAllToken()
                // const currentTime = moment().format(dateTimeFormat)
                // const duration = moment.duration(moment.unix(expires_on).diff(currentTime))
                // const minutes = duration.asMinutes()

                // if (minutes < 10) {
                //     console.log('request new token')
                //     fetch(`${CORE_API_ENDPOINT}/user/refeshtoken`, {
                //         method: 'POST',
                //         headers: {
                //             'Content-Type': 'application/json'
                //         },
                //         body: JSON.stringify({ access_token })
                //     })
                //         .then(res => res.json())
                //         .then(json => setToken(json))
                //         .then(() => next(action))
                // } else {
                //     next(action)
                // }
            } else {
                next(action);
            }
        };
    };
});
// CONCATENATED MODULE: ./src/middlewares/setToken.js
var setToken__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var setToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



// import types from '../types'
/* harmony default export */ var setToken = (function (store) {
	return function (next) {
		return function (action) {

			var entry = action[CALL_API];
			// const ignorTypes  = [types.]
			if ((typeof entry === 'undefined' ? 'undefined' : setToken__typeof(entry)) !== 'object') return next(action);

			var token = void 0;
			var entryType = entry.types[0];

			if (entryType.startsWith("CORE")) {
				token = Object(lib["h" /* getToken */])();
			}
			// else if(entry.types[0].startsWith("O365")){ 
			//   token = getAccessToken()
			// }

			if (!token) return next(action);

			entry.headers = setToken__extends({}, entry.headers);
			if (token) {
				entry.headers.Authorization = 'Bearer ' + token;
			}

			next(action);
		};
	};
});
// CONCATENATED MODULE: ./src/middlewares/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return api; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return CALL_API; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return checkToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return setToken; });




/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(229);


/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hot_loader__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root__);





var render = function render(Component) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_hot_loader__["AppContainer"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, null)
    ), document.getElementById('root'));
};

render(__WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root___default.a);

if (false) {
    module.hot.accept('./features/ui/components/Root', function () {
        return render(RootContainer);
    });
}

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(237);
} else {
    module.exports = require('./Root.dev');
}

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-router-dom/es/index.js + 29 modules
var es = __webpack_require__(120);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var react_redux_es = __webpack_require__(26);

// EXTERNAL MODULE: ./node_modules/normalizr/dist/normalizr.es.js
var normalizr_es = __webpack_require__(244);

// CONCATENATED MODULE: ./src/store/schema.js


var eventSchema = new normalizr_es["a" /* schema */].Entity('events');
// EXTERNAL MODULE: ./src/store/configureStore.js
var configureStore = __webpack_require__(245);
var configureStore_default = /*#__PURE__*/__webpack_require__.n(configureStore);

// CONCATENATED MODULE: ./src/store/index.js


// EXTERNAL MODULE: ./node_modules/react-loadable/lib/index.js
var lib = __webpack_require__(266);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/semantic-ui-react/dist/es/index.js + 257 modules
var dist_es = __webpack_require__(118);

// CONCATENATED MODULE: ./src/features/ui/components/Loadable.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Loadable_Loading = function Loading() {
    return (
        // <div>Loading...</div>
        react_default.a.createElement(
            dist_es["e" /* Dimmer */],
            { active: true },
            react_default.a.createElement(
                dist_es["m" /* Loader */],
                { size: 'large' },
                'Loading'
            )
        )
    );
};

/* harmony default export */ var Loadable = (function (opts) {
    return lib_default()(_extends({
        loading: Loadable_Loading
    }, opts));
});
// EXTERNAL MODULE: ./src/lib/index.js + 3 modules
var src_lib = __webpack_require__(119);

// CONCATENATED MODULE: ./src/lib/routePermission.js
var routePermission__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var Auth = {
	isAuthenticated: function isAuthenticated() {
		var token = Object(src_lib["h" /* getToken */])();
		return !!token;
	}
};

var routePermission_PrivateRoute = function PrivateRoute(_ref) {
	var Component = _ref.component,
	    rest = _objectWithoutProperties(_ref, ['component']),
	    browserHistory = _ref.browserHistory;

	return react_default.a.createElement(es["c" /* Route */], routePermission__extends({}, rest, { render: function render(props) {
			if (Auth.isAuthenticated() === false && props.match.url !== "/login") {
				return react_default.a.createElement(es["b" /* Redirect */], { to: '/login' });
			}

			if (Component !== undefined) {
				return react_default.a.createElement(Component, props);
			} else {
				return react_default.a.createElement(es["b" /* Redirect */], { to: '/' });
			}
		}, browserHistory: browserHistory }));
};

var routePermission_PublicRoute = function PublicRoute(_ref2) {
	var Component = _ref2.component,
	    rest = _objectWithoutProperties(_ref2, ['component']);

	return react_default.a.createElement(es["c" /* Route */], routePermission__extends({}, rest, { render: function render(props) {

			if (Auth.isAuthenticated() === true && props.match.url === "/login") {
				return react_default.a.createElement(es["b" /* Redirect */], { to: '/' });
			}

			if (Component !== undefined) {
				return react_default.a.createElement(Component, props);
			} else {
				return "";
			}
		} }));
};


// CONCATENATED MODULE: ./src/features/ui/components/Routes.js


// import { Route } from 'react-router'



var AsyncHome = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1091));
    }
});

var AsyncNotFound = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1092));
    }
});

var AsyncNoPer = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 1093));
    }
});

var AsyncLogin = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1094));
    }
});

//CUSTOMER
var AsyncAllCustomer = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1095));
    }
});
var AsyncCreateCustomer = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1096));
    }
});
var AsyncUpdateCustomer = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1097));
    }
});
var AsyncCustomerInfo = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1098));
    }
});

//CONTACT
var AsyncAllContact = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1099));
    }
});
var AsyncCreateContact = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1100));
    }
});
var AsyncUpdateContact = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1101));
    }
});
var AsyncContactInfo = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1102));
    }
});

//PRODUCT
var AsyncAllProduct = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1103));
    }
});
var AsyncCreateProduct = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1104));
    }
});
var AsyncUpdateProduct = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1105));
    }
});
var AsyncProductInfo = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1106));
    }
});

//PROFILE
var AsyncAllProfile = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1107));
    }
});
var AsyncCreateProfile = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1108));
    }
});
var AsyncUpdateProfile = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1109));
    }
});
var AsyncProfileInfo = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1110));
    }
});

//USER
var AsyncAllUser = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1111));
    }
});
var AsyncCreateUser = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1112));
    }
});
var AsyncUpdateUser = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1113));
    }
});
var AsyncUserInfo = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1114));
    }
});

//DEVICE
var AsyncAllDevice = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1115));
    }
});
var AsyncCreateDevice = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1116));
    }
});
var AsyncUpdateDevice = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1117));
    }
});
var AsyncDeviceInfo = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1118));
    }
});

//IOTAccessory
var AsyncAllIOTAccessory = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1119));
    }
});
var AsyncCreateIOTAccessory = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1120));
    }
});
var AsyncUpdateIOTAccessory = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1121));
    }
});
var AsyncIOTAccessoryInfo = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1122));
    }
});

// const AsyncHome = Loadable({
//     loader: () => import('./Pages/CustomPage')
// })


/* harmony default export */ var Routes = (function () {
    return react_default.a.createElement(
        es["d" /* Switch */],
        null,
        react_default.a.createElement(routePermission_PrivateRoute, { exact: true, path: '/', component: AsyncHome }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/login', component: AsyncLogin }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/noaccess', component: AsyncNoPer }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/customer', component: AsyncAllCustomer }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/customer_create', component: AsyncCreateCustomer }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/customer_update/:id', component: AsyncUpdateCustomer }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/customer_info/:id', component: AsyncCustomerInfo }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/contact', component: AsyncAllContact }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/contact_create', component: AsyncCreateContact }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/contact_update/:id', component: AsyncUpdateContact }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/contact_info/:id', component: AsyncContactInfo }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/product', component: AsyncAllProduct }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/product_create', component: AsyncCreateProduct }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/product_update/:id', component: AsyncUpdateProduct }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/product_info/:id', component: AsyncProductInfo }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/profile', component: AsyncAllProfile }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/profile_create', component: AsyncCreateProfile }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/profile_update/:id', component: AsyncUpdateProfile }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/profile_info/:id', component: AsyncProfileInfo }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/user', component: AsyncAllUser }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/user_create', component: AsyncCreateUser }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/user_update/:id', component: AsyncUpdateUser }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/user_info/:id', component: AsyncUserInfo }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/device', component: AsyncAllDevice }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/device_create', component: AsyncCreateDevice }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/device_update/:id', component: AsyncUpdateDevice }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/device_info/:id', component: AsyncDeviceInfo }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/iotaccessory', component: AsyncAllIOTAccessory }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/iotaccessory_create', component: AsyncCreateIOTAccessory }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/iotaccessory_update/:id', component: AsyncUpdateIOTAccessory }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/iotaccessory_info/:id', component: AsyncIOTAccessoryInfo }),
        react_default.a.createElement(routePermission_PrivateRoute, { component: AsyncNotFound })
    );
});
// CONCATENATED MODULE: ./src/features/ui/components/App.js



/* harmony default export */ var App = (function () {
    return react_default.a.createElement(
        'div',
        { className: 'height100' },
        react_default.a.createElement(
            'div',
            { className: 'height100' },
            react_default.a.createElement(Routes, null)
        )
    );
});
// EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js
var Recompose = __webpack_require__(148);

// CONCATENATED MODULE: ./src/features/ui/selectors.js
function getIsLoading(state) {
    return state.ui.isLoading;
}

function getHasError(state) {
    return state.ui.hasError;
}

function getErrorMessage(state) {
    return state.ui.errorMessage;
}

function getErrorCode(state) {
    return state.ui.errorCode;
}

function getUiMessage(state) {
    return state.ui;
}

function getError(state) {
    return state.ui.error;
}
// EXTERNAL MODULE: ./src/types.js
var types = __webpack_require__(21);

// CONCATENATED MODULE: ./src/error.js

// 0000 => api error
// 0001 => backend error
// 0002 => fronted error

var errorMessage = {
	// default error
	"00010000": "Something went wrong. Please try again later.",

	// custom error
	"00010001": "asfsdfdsfdsf sdfdsf dsf"
};

/* harmony default export */ var src_error = ({
	errorMessage: errorMessage
});
// CONCATENATED MODULE: ./src/features/ui/actions.js





function setError(hasError) {
	var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	var defaultError = {
		code: "00010000",
		message: src_error["00010000"]
	};

	if (typeof error === 'string' && error in src_error) {
		defaultError = {
			code: error,
			message: src_error[error]
		};
	} else if (error === null || hasError === false) {
		defaultError = null;
	} else if (error.code !== undefined && error.message !== undefined) {
		defaultError = error;
	}

	return {
		type: types["_129" /* SET_ERROR */],
		hasError: hasError,
		error: defaultError
	};
}
// CONCATENATED MODULE: ./src/features/ui/components/ErrorMessageDialog.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ErrorMessageDialog_ErrorMessageDialog = function (_React$Component) {
	_inherits(ErrorMessageDialog, _React$Component);

	function ErrorMessageDialog() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, ErrorMessageDialog);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ErrorMessageDialog.__proto__ || Object.getPrototypeOf(ErrorMessageDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = { open: _this.props.hasError }, _this.close = function () {
			_this.setState({ open: false });
			_this.props.clearError();
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(ErrorMessageDialog, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProp) {
			this.setState({ open: nextProp.hasError });
		}
	}, {
		key: 'render',
		value: function render() {
			return react_default.a.createElement(
				dist_es["o" /* Modal */],
				{ open: this.state.open, onClose: this.close },
				react_default.a.createElement(
					dist_es["o" /* Modal */].Header,
					null,
					react_default.a.createElement(
						'h3',
						null,
						'System Message'
					)
				),
				react_default.a.createElement(
					dist_es["o" /* Modal */].Content,
					null,
					this.props.hasError && this.props.error && this.props.error.code !== undefined && this.props.error.message !== undefined ? react_default.a.createElement(
						dist_es["o" /* Modal */].Description,
						null,
						react_default.a.createElement(
							'div',
							null,
							react_default.a.createElement(
								'h3',
								{ className: 'view-display' },
								'Error Code : '
							),
							react_default.a.createElement(
								'h3',
								{ className: 'view-display view-font-value' },
								this.props.error.code
							)
						),
						react_default.a.createElement(
							'div',
							null,
							react_default.a.createElement(
								'h3',
								{ className: 'view-display' },
								'Error Message : '
							),
							react_default.a.createElement(
								'h3',
								{ className: 'view-display view-font-value' },
								this.props.error.message
							)
						)
					) : react_default.a.createElement(
						dist_es["o" /* Modal */].Description,
						null,
						react_default.a.createElement(
							'h3',
							{ className: 'view-display view-font-value' },
							'Something went wrong !'
						)
					)
				),
				react_default.a.createElement(
					dist_es["o" /* Modal */].Actions,
					null,
					react_default.a.createElement(
						dist_es["b" /* Button */],
						{
							className: 'buttonSubmit',
							onClick: this.close },
						'Ok'
					)
				)
			);
		}
	}]);

	return ErrorMessageDialog;
}(react_default.a.Component);

/* harmony default export */ var components_ErrorMessageDialog = (Object(Recompose["a" /* compose */])(Object(react_redux_es["connect"])(function (state, props) {
	return {
		hasError: getHasError(state),
		error: getError(state)
	};
}, function (dispatch) {
	return {
		clearError: function clearError() {
			dispatch(setError(false));
		}
	};
}))(ErrorMessageDialog_ErrorMessageDialog));
// CONCATENATED MODULE: ./src/features/ui/components/LoadingDialog.js
var LoadingDialog__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var LoadingDialog_LoadingDialog = function LoadingDialog(props) {
	return props.isLoading ? react_default.a.createElement(
		dist_es["e" /* Dimmer */],
		{ active: true },
		react_default.a.createElement(
			dist_es["m" /* Loader */],
			{ size: 'large' },
			'Loading'
		)
	) : "";
};

/* harmony default export */ var components_LoadingDialog = (Object(Recompose["a" /* compose */])(Object(react_redux_es["connect"])(function (state) {
	return {
		isLoading: getIsLoading(state)
	};
}), Object(Recompose["c" /* withProps */])(function (props) {
	return LoadingDialog__extends({}, props);
}))(LoadingDialog_LoadingDialog));
// CONCATENATED MODULE: ./src/features/ui/components/Root.prod.js





// import { Container } from 'semantic-ui-react'



var store = configureStore_default()();

/* harmony default export */ var Root_prod = __webpack_exports__["default"] = (function () {
    return react_default.a.createElement(
        react_redux_es["Provider"],
        { store: store },
        react_default.a.createElement(
            es["a" /* BrowserRouter */],
            null,
            react_default.a.createElement(
                'div',
                { className: 'height100' },
                react_default.a.createElement(App, null),
                react_default.a.createElement(components_ErrorMessageDialog, null),
                react_default.a.createElement(components_LoadingDialog, null)
            )
        )
    );
});

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(246);
} else {
    module.exports = require('./configureStore.dev');
}

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var es = __webpack_require__(59);

// EXTERNAL MODULE: ./node_modules/redux-thunk/es/index.js
var redux_thunk_es = __webpack_require__(247);

// EXTERNAL MODULE: ./src/middlewares/index.js + 3 modules
var src_middlewares = __webpack_require__(224);

// EXTERNAL MODULE: ./node_modules/redux-form/es/index.js + 228 modules
var redux_form_es = __webpack_require__(249);

// EXTERNAL MODULE: ./node_modules/reapop/lib/index.js
var lib = __webpack_require__(254);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./src/types.js
var types = __webpack_require__(21);

// CONCATENATED MODULE: ./src/features/ui/reducer.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var reducer_initialState = {
    hasError: false,
    isLoading: false,
    errorMessage: '',
    errorCode: '',
    statusText: ''
};

/* harmony default export */ var reducer = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
        case types["_9" /* CORE_LOAD_ALL_CONTACT_REQUEST */]:
        case types["_48" /* CORE_LOAD_CONTACT_REQUEST */]:
        case types["F" /* CORE_DELETE_CONTACT_REQUEST */]:
        case types["b" /* CORE_CREATE_CONTACT_REQUEST */]:
        case types["_90" /* CORE_UPDATE_CONTACT_REQUEST */]:
        case types["_12" /* CORE_LOAD_ALL_CUSTOMER_REQUEST */]:
        case types["_51" /* CORE_LOAD_CUSTOMER_REQUEST */]:
        case types["I" /* CORE_DELETE_CUSTOMER_REQUEST */]:
        case types["e" /* CORE_CREATE_CUSTOMER_REQUEST */]:
        case types["_93" /* CORE_UPDATE_CUSTOMER_REQUEST */]:
        case types["_15" /* CORE_LOAD_ALL_DEVICE_REQUEST */]:
        case types["_54" /* CORE_LOAD_DEVICE_REQUEST */]:
        case types["L" /* CORE_DELETE_DEVICE_REQUEST */]:
        case types["h" /* CORE_CREATE_DEVICE_REQUEST */]:
        case types["_96" /* CORE_UPDATE_DEVICE_REQUEST */]:
        case types["_18" /* CORE_LOAD_ALL_IOTACCESSORY_REQUEST */]:
        case types["_57" /* CORE_LOAD_IOTACCESSORY_REQUEST */]:
        case types["O" /* CORE_DELETE_IOTACCESSORY_REQUEST */]:
        case types["k" /* CORE_CREATE_IOTACCESSORY_REQUEST */]:
        case types["_99" /* CORE_UPDATE_IOTACCESSORY_REQUEST */]:
        case types["_21" /* CORE_LOAD_ALL_IOTROOM_REQUEST */]:
        case types["_60" /* CORE_LOAD_IOTROOM_REQUEST */]:
        case types["R" /* CORE_DELETE_IOTROOM_REQUEST */]:
        case types["n" /* CORE_CREATE_IOTROOM_REQUEST */]:
        case types["_102" /* CORE_UPDATE_IOTROOM_REQUEST */]:
        case types["_84" /* CORE_UNREGISTER_IOTROOM_LICENSE_REQUEST */]:
        case types["_33" /* CORE_LOAD_ALL_LICENSE_REQUEST */]:
        case types["_27" /* CORE_LOAD_ALL_LICENSE_DISPLAY_REQUEST */]:
        case types["_31" /* CORE_LOAD_ALL_LICENSE_IOT_REQUEST */]:
        case types["_66" /* CORE_LOAD_LICENSE_REQUEST */]:
        case types["U" /* CORE_DELETE_LICENSE_REQUEST */]:
        case types["q" /* CORE_CREATE_LICENSE_REQUEST */]:
        case types["_105" /* CORE_UPDATE_LICENSE_REQUEST */]:
        case types["_24" /* CORE_LOAD_ALL_LICENSETYPE_REQUEST */]:
        case types["_63" /* CORE_LOAD_LICENSETYPE_REQUEST */]:
        case types["_36" /* CORE_LOAD_ALL_PRODUCT_REQUEST */]:
        case types["_69" /* CORE_LOAD_PRODUCT_REQUEST */]:
        case types["X" /* CORE_DELETE_PRODUCT_REQUEST */]:
        case types["t" /* CORE_CREATE_PRODUCT_REQUEST */]:
        case types["_108" /* CORE_UPDATE_PRODUCT_REQUEST */]:
        case types["_120" /* CORE_UPVERSION_PRODUCT_REQUEST */]:
        case types["_39" /* CORE_LOAD_ALL_PROFILE_REQUEST */]:
        case types["_72" /* CORE_LOAD_PROFILE_REQUEST */]:
        case types["_0" /* CORE_DELETE_PROFILE_REQUEST */]:
        case types["w" /* CORE_CREATE_PROFILE_REQUEST */]:
        case types["_111" /* CORE_UPDATE_PROFILE_REQUEST */]:
        case types["_126" /* CORE_USER_VERIFY_REQUEST */]:
        case types["_42" /* CORE_LOAD_ALL_USER_REQUEST */]:
        case types["_78" /* CORE_LOAD_USER_REQUEST */]:
        case types["_3" /* CORE_DELETE_USER_REQUEST */]:
        case types["z" /* CORE_CREATE_USER_REQUEST */]:
        case types["_114" /* CORE_UPDATE_USER_REQUEST */]:
        case types["_45" /* CORE_LOAD_ALL_VERSION_REQUEST */]:
        case types["_81" /* CORE_LOAD_VERSION_REQUEST */]:
        case types["_6" /* CORE_DELETE_VERSION_REQUEST */]:
        case types["C" /* CORE_CREATE_VERSION_REQUEST */]:
        case types["_117" /* CORE_UPDATE_VERSION_REQUEST */]:
            return _extends({}, state, {
                isLoading: true,
                hasError: false,
                errorMessage: '',
                errorCode: '',
                statusText: ''
            });
        case types["_10" /* CORE_LOAD_ALL_CONTACT_SUCCESS */]:
        case types["_49" /* CORE_LOAD_CONTACT_SUCCESS */]:
        case types["G" /* CORE_DELETE_CONTACT_SUCCESS */]:
        case types["c" /* CORE_CREATE_CONTACT_SUCCESS */]:
        case types["_91" /* CORE_UPDATE_CONTACT_SUCCESS */]:
        case types["_13" /* CORE_LOAD_ALL_CUSTOMER_SUCCESS */]:
        case types["_52" /* CORE_LOAD_CUSTOMER_SUCCESS */]:
        case types["J" /* CORE_DELETE_CUSTOMER_SUCCESS */]:
        case types["f" /* CORE_CREATE_CUSTOMER_SUCCESS */]:
        case types["_94" /* CORE_UPDATE_CUSTOMER_SUCCESS */]:
        case types["_16" /* CORE_LOAD_ALL_DEVICE_SUCCESS */]:
        case types["_55" /* CORE_LOAD_DEVICE_SUCCESS */]:
        case types["M" /* CORE_DELETE_DEVICE_SUCCESS */]:
        case types["i" /* CORE_CREATE_DEVICE_SUCCESS */]:
        case types["_97" /* CORE_UPDATE_DEVICE_SUCCESS */]:
        case types["_19" /* CORE_LOAD_ALL_IOTACCESSORY_SUCCESS */]:
        case types["_58" /* CORE_LOAD_IOTACCESSORY_SUCCESS */]:
        case types["P" /* CORE_DELETE_IOTACCESSORY_SUCCESS */]:
        case types["l" /* CORE_CREATE_IOTACCESSORY_SUCCESS */]:
        case types["_100" /* CORE_UPDATE_IOTACCESSORY_SUCCESS */]:
        case types["_22" /* CORE_LOAD_ALL_IOTROOM_SUCCESS */]:
        case types["_61" /* CORE_LOAD_IOTROOM_SUCCESS */]:
        case types["S" /* CORE_DELETE_IOTROOM_SUCCESS */]:
        case types["o" /* CORE_CREATE_IOTROOM_SUCCESS */]:
        case types["_103" /* CORE_UPDATE_IOTROOM_SUCCESS */]:
        case types["_85" /* CORE_UNREGISTER_IOTROOM_LICENSE_SUCCESS */]:
        case types["_34" /* CORE_LOAD_ALL_LICENSE_SUCCESS */]:
        case types["_28" /* CORE_LOAD_ALL_LICENSE_DISPLAY_SUCCESS */]:
        case types["_32" /* CORE_LOAD_ALL_LICENSE_IOT_SUCCESS */]:
        case types["_67" /* CORE_LOAD_LICENSE_SUCCESS */]:
        case types["V" /* CORE_DELETE_LICENSE_SUCCESS */]:
        case types["r" /* CORE_CREATE_LICENSE_SUCCESS */]:
        case types["_106" /* CORE_UPDATE_LICENSE_SUCCESS */]:
        case types["_25" /* CORE_LOAD_ALL_LICENSETYPE_SUCCESS */]:
        case types["_64" /* CORE_LOAD_LICENSETYPE_SUCCESS */]:
        case types["_37" /* CORE_LOAD_ALL_PRODUCT_SUCCESS */]:
        case types["_70" /* CORE_LOAD_PRODUCT_SUCCESS */]:
        case types["Y" /* CORE_DELETE_PRODUCT_SUCCESS */]:
        case types["u" /* CORE_CREATE_PRODUCT_SUCCESS */]:
        case types["_109" /* CORE_UPDATE_PRODUCT_SUCCESS */]:
        case types["_121" /* CORE_UPVERSION_PRODUCT_SUCCESS */]:
        case types["_40" /* CORE_LOAD_ALL_PROFILE_SUCCESS */]:
        case types["_73" /* CORE_LOAD_PROFILE_SUCCESS */]:
        case types["_1" /* CORE_DELETE_PROFILE_SUCCESS */]:
        case types["x" /* CORE_CREATE_PROFILE_SUCCESS */]:
        case types["_112" /* CORE_UPDATE_PROFILE_SUCCESS */]:
        case types["_127" /* CORE_USER_VERIFY_SUCCESS */]:
        case types["_43" /* CORE_LOAD_ALL_USER_SUCCESS */]:
        case types["_79" /* CORE_LOAD_USER_SUCCESS */]:
        case types["_4" /* CORE_DELETE_USER_SUCCESS */]:
        case types["A" /* CORE_CREATE_USER_SUCCESS */]:
        case types["_115" /* CORE_UPDATE_USER_SUCCESS */]:
        case types["_46" /* CORE_LOAD_ALL_VERSION_SUCCESS */]:
        case types["_82" /* CORE_LOAD_VERSION_SUCCESS */]:
        case types["_7" /* CORE_DELETE_VERSION_SUCCESS */]:
        case types["D" /* CORE_CREATE_VERSION_SUCCESS */]:
        case types["_118" /* CORE_UPDATE_VERSION_SUCCESS */]:
            return _extends({}, state, {
                isLoading: false,
                // hasError: false,
                errorMessage: '',
                errorCode: '',
                statusText: ''
            });
        case types["_8" /* CORE_LOAD_ALL_CONTACT_FAILURE */]:
        case types["_47" /* CORE_LOAD_CONTACT_FAILURE */]:
        case types["E" /* CORE_DELETE_CONTACT_FAILURE */]:
        case types["a" /* CORE_CREATE_CONTACT_FAILURE */]:
        case types["_89" /* CORE_UPDATE_CONTACT_FAILURE */]:
        case types["_11" /* CORE_LOAD_ALL_CUSTOMER_FAILURE */]:
        case types["_50" /* CORE_LOAD_CUSTOMER_FAILURE */]:
        case types["H" /* CORE_DELETE_CUSTOMER_FAILURE */]:
        case types["d" /* CORE_CREATE_CUSTOMER_FAILURE */]:
        case types["_92" /* CORE_UPDATE_CUSTOMER_FAILURE */]:
        case types["_14" /* CORE_LOAD_ALL_DEVICE_FAILURE */]:
        case types["_53" /* CORE_LOAD_DEVICE_FAILURE */]:
        case types["K" /* CORE_DELETE_DEVICE_FAILURE */]:
        case types["g" /* CORE_CREATE_DEVICE_FAILURE */]:
        case types["_95" /* CORE_UPDATE_DEVICE_FAILURE */]:
        case types["_17" /* CORE_LOAD_ALL_IOTACCESSORY_FAILURE */]:
        case types["_56" /* CORE_LOAD_IOTACCESSORY_FAILURE */]:
        case types["N" /* CORE_DELETE_IOTACCESSORY_FAILURE */]:
        case types["j" /* CORE_CREATE_IOTACCESSORY_FAILURE */]:
        case types["_98" /* CORE_UPDATE_IOTACCESSORY_FAILURE */]:
        case types["_20" /* CORE_LOAD_ALL_IOTROOM_FAILURE */]:
        case types["_59" /* CORE_LOAD_IOTROOM_FAILURE */]:
        case types["Q" /* CORE_DELETE_IOTROOM_FAILURE */]:
        case types["m" /* CORE_CREATE_IOTROOM_FAILURE */]:
        case types["_101" /* CORE_UPDATE_IOTROOM_FAILURE */]:
        case types["_83" /* CORE_UNREGISTER_IOTROOM_LICENSE_FAILURE */]:
        case types["_29" /* CORE_LOAD_ALL_LICENSE_FAILURE */]:
        case types["_26" /* CORE_LOAD_ALL_LICENSE_DISPLAY_FAILURE */]:
        case types["_30" /* CORE_LOAD_ALL_LICENSE_IOT_FAILURE */]:
        case types["_65" /* CORE_LOAD_LICENSE_FAILURE */]:
        case types["T" /* CORE_DELETE_LICENSE_FAILURE */]:
        case types["p" /* CORE_CREATE_LICENSE_FAILURE */]:
        case types["_104" /* CORE_UPDATE_LICENSE_FAILURE */]:
        case types["_23" /* CORE_LOAD_ALL_LICENSETYPE_FAILURE */]:
        case types["_62" /* CORE_LOAD_LICENSETYPE_FAILURE */]:
        case types["_35" /* CORE_LOAD_ALL_PRODUCT_FAILURE */]:
        case types["_68" /* CORE_LOAD_PRODUCT_FAILURE */]:
        case types["W" /* CORE_DELETE_PRODUCT_FAILURE */]:
        case types["s" /* CORE_CREATE_PRODUCT_FAILURE */]:
        case types["_107" /* CORE_UPDATE_PRODUCT_FAILURE */]:
        case types["_119" /* CORE_UPVERSION_PRODUCT_FAILURE */]:
        case types["_38" /* CORE_LOAD_ALL_PROFILE_FAILURE */]:
        case types["_71" /* CORE_LOAD_PROFILE_FAILURE */]:
        case types["Z" /* CORE_DELETE_PROFILE_FAILURE */]:
        case types["v" /* CORE_CREATE_PROFILE_FAILURE */]:
        case types["_110" /* CORE_UPDATE_PROFILE_FAILURE */]:
        case types["_125" /* CORE_USER_VERIFY_FAILURE */]:
        case types["_41" /* CORE_LOAD_ALL_USER_FAILURE */]:
        case types["_77" /* CORE_LOAD_USER_FAILURE */]:
        case types["_2" /* CORE_DELETE_USER_FAILURE */]:
        case types["y" /* CORE_CREATE_USER_FAILURE */]:
        case types["_113" /* CORE_UPDATE_USER_FAILURE */]:
        case types["_44" /* CORE_LOAD_ALL_VERSION_FAILURE */]:
        case types["_80" /* CORE_LOAD_VERSION_FAILURE */]:
        case types["_5" /* CORE_DELETE_VERSION_FAILURE */]:
        case types["B" /* CORE_CREATE_VERSION_FAILURE */]:
        case types["_116" /* CORE_UPDATE_VERSION_FAILURE */]:
            var returnData = _extends({}, state, {
                isLoading: false,
                hasError: true,
                error: action.payload
            });
            return returnData;
        default:
            return state;
    }
});
// CONCATENATED MODULE: ./src/reducers/reducerDeleteState.js


var reducerDeleteState_initialState = {
  status: false,
  date: '',
  id: ''
};
/* harmony default export */ var reducerDeleteState = ({
  deleteState: function deleteState() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerDeleteState_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["I" /* CORE_DELETE_CUSTOMER_REQUEST */]:
      case types["F" /* CORE_DELETE_CONTACT_REQUEST */]:
      case types["X" /* CORE_DELETE_PRODUCT_REQUEST */]:
      case types["_6" /* CORE_DELETE_VERSION_REQUEST */]:
      case types["_0" /* CORE_DELETE_PROFILE_REQUEST */]:
      case types["L" /* CORE_DELETE_DEVICE_REQUEST */]:
      case types["O" /* CORE_DELETE_IOTACCESSORY_REQUEST */]:
      case types["R" /* CORE_DELETE_IOTROOM_REQUEST */]:
      case types["_3" /* CORE_DELETE_USER_REQUEST */]:
      case types["U" /* CORE_DELETE_LICENSE_REQUEST */]:
        return reducerDeleteState_initialState;
      case types["J" /* CORE_DELETE_CUSTOMER_SUCCESS */]:
      case types["G" /* CORE_DELETE_CONTACT_SUCCESS */]:
      case types["Y" /* CORE_DELETE_PRODUCT_SUCCESS */]:
      case types["_7" /* CORE_DELETE_VERSION_SUCCESS */]:
      case types["_1" /* CORE_DELETE_PROFILE_SUCCESS */]:
      case types["M" /* CORE_DELETE_DEVICE_SUCCESS */]:
      case types["P" /* CORE_DELETE_IOTACCESSORY_SUCCESS */]:
      case types["S" /* CORE_DELETE_IOTROOM_SUCCESS */]:
      case types["_4" /* CORE_DELETE_USER_SUCCESS */]:
      case types["V" /* CORE_DELETE_LICENSE_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/reducers/reducerCustomer.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var reducerCustomer_initialState = [],
    initialStateObj = {},
    requestState = types["_128" /* REQUEST_STATE */];
/* harmony default export */ var reducerCustomer = ({
  allCustomer: function allCustomer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_12" /* CORE_LOAD_ALL_CUSTOMER_REQUEST */]:
        return requestState;
      case types["_13" /* CORE_LOAD_ALL_CUSTOMER_SUCCESS */]:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload;
        } else return [];
      case types["_11" /* CORE_LOAD_ALL_CUSTOMER_FAILURE */]:
        return reducerCustomer_initialState;
      default:
        return state;
    }
  },
  customerInfo: function customerInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_51" /* CORE_LOAD_CUSTOMER_REQUEST */]:
        return requestState;
      case types["_52" /* CORE_LOAD_CUSTOMER_SUCCESS */]:
        if (action.payload && _typeof(action.payload) === 'object' && !Array.isArray(action.payload)) {
          return action.payload;
        } else return {};
      case types["_50" /* CORE_LOAD_CUSTOMER_FAILURE */]:
        return initialStateObj;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/reducers/reducerContact.js
var reducerContact__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var reducerContact_initialState = [],
    reducerContact_initialStateObj = {},
    reducerContact_requestState = types["_128" /* REQUEST_STATE */];
/* harmony default export */ var reducerContact = ({
  allContact: function allContact() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerContact_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_9" /* CORE_LOAD_ALL_CONTACT_REQUEST */]:
        return reducerContact_requestState;
      case types["_10" /* CORE_LOAD_ALL_CONTACT_SUCCESS */]:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload;
        } else return [];
      case types["_8" /* CORE_LOAD_ALL_CONTACT_FAILURE */]:
        return reducerContact_initialState;
      default:
        return state;
    }
  },
  searchContact: function searchContact() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerContact_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_75" /* CORE_LOAD_SEARCH_CONTACT_REQUEST */]:
        return reducerContact_requestState;
      case types["_76" /* CORE_LOAD_SEARCH_CONTACT_SUCCESS */]:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload;
        } else return [];
      case types["_74" /* CORE_LOAD_SEARCH_CONTACT_FAILURE */]:
        return reducerContact_initialState;
      default:
        return state;
    }
  },
  contactInfo: function contactInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerContact_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_48" /* CORE_LOAD_CONTACT_REQUEST */]:
        return reducerContact_requestState;
      case types["_49" /* CORE_LOAD_CONTACT_SUCCESS */]:
        if (action.payload && reducerContact__typeof(action.payload) === 'object' && !Array.isArray(action.payload)) {
          return action.payload;
        } else return {};
      case types["_47" /* CORE_LOAD_CONTACT_FAILURE */]:
        return reducerContact_initialStateObj;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/reducers/reducerProfile.js
var reducerProfile__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var reducerProfile_initialState = [],
    reducerProfile_initialStateObj = {},
    reducerProfile_requestState = types["_128" /* REQUEST_STATE */];
/* harmony default export */ var reducerProfile = ({
  allProfile: function allProfile() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerProfile_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_39" /* CORE_LOAD_ALL_PROFILE_REQUEST */]:
        return reducerProfile_requestState;
      case types["_40" /* CORE_LOAD_ALL_PROFILE_SUCCESS */]:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload;
        } else return [];
      case types["_38" /* CORE_LOAD_ALL_PROFILE_FAILURE */]:
        return reducerProfile_initialState;
      default:
        return state;
    }
  },
  profileInfo: function profileInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerProfile_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_72" /* CORE_LOAD_PROFILE_REQUEST */]:
        return reducerProfile_requestState;
      case types["_73" /* CORE_LOAD_PROFILE_SUCCESS */]:
        if (action.payload && reducerProfile__typeof(action.payload) === 'object' && !Array.isArray(action.payload)) {
          return action.payload;
        } else return {};
      case types["_71" /* CORE_LOAD_PROFILE_FAILURE */]:
        return reducerProfile_initialStateObj;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/reducers/reducerProduct.js
var reducerProduct__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var reducerProduct_initialState = [],
    reducerProduct_initialStateObj = {},
    reducerProduct_requestState = types["_128" /* REQUEST_STATE */],
    versionState = {
  status: false,
  date: '',
  type: '',
  id: ''
};
/* harmony default export */ var reducerProduct = ({
  allProduct: function allProduct() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerProduct_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_36" /* CORE_LOAD_ALL_PRODUCT_REQUEST */]:
        return reducerProduct_requestState;
      case types["_37" /* CORE_LOAD_ALL_PRODUCT_SUCCESS */]:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload;
        } else return [];
      case types["_35" /* CORE_LOAD_ALL_PRODUCT_FAILURE */]:
        return reducerProduct_initialState;
      default:
        return state;
    }
  },
  productInfo: function productInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerProduct_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_69" /* CORE_LOAD_PRODUCT_REQUEST */]:
        return reducerProduct_requestState;
      case types["_70" /* CORE_LOAD_PRODUCT_SUCCESS */]:
        if (action.payload && reducerProduct__typeof(action.payload) === 'object' && !Array.isArray(action.payload)) {
          return action.payload;
        } else return {};
      case types["_68" /* CORE_LOAD_PRODUCT_FAILURE */]:
        return reducerProduct_initialStateObj;
      default:
        return state;
    }
  },
  versionProduct: function versionProduct() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : versionState;
    var action = arguments[1];

    switch (action.type) {
      case types["_120" /* CORE_UPVERSION_PRODUCT_REQUEST */]:
        return versionState;
      case types["_121" /* CORE_UPVERSION_PRODUCT_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/reducers/reducerVersion.js
var reducerVersion__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var reducerVersion_initialState = [],
    reducerVersion_initialStateObj = {},
    reducerVersion_requestState = types["_128" /* REQUEST_STATE */];
/* harmony default export */ var reducerVersion = ({
  allVersion: function allVersion() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerVersion_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_45" /* CORE_LOAD_ALL_VERSION_REQUEST */]:
        return reducerVersion_requestState;
      case types["_46" /* CORE_LOAD_ALL_VERSION_SUCCESS */]:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload;
        } else return [];
      case types["_44" /* CORE_LOAD_ALL_VERSION_FAILURE */]:
        return reducerVersion_initialState;
      default:
        return state;
    }
  },
  versionInfo: function versionInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerVersion_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_81" /* CORE_LOAD_VERSION_REQUEST */]:
        return reducerVersion_requestState;
      case types["_82" /* CORE_LOAD_VERSION_SUCCESS */]:
        if (action.payload && reducerVersion__typeof(action.payload) === 'object' && !Array.isArray(action.payload)) {
          return action.payload;
        } else return {};
      case types["_80" /* CORE_LOAD_VERSION_FAILURE */]:
        return reducerVersion_initialStateObj;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/reducers/reducerUser.js
var reducerUser__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var reducerUser_initialState = [],
    reducerUser_initialStateObj = {},
    reducerUser_requestState = types["_128" /* REQUEST_STATE */];
/* harmony default export */ var reducerUser = ({
   allUser: function allUser() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerUser_requestState;
      var action = arguments[1];

      switch (action.type) {
         case types["_42" /* CORE_LOAD_ALL_USER_REQUEST */]:
            return reducerUser_requestState;
         case types["_43" /* CORE_LOAD_ALL_USER_SUCCESS */]:
            if (action.payload && Array.isArray(action.payload)) {
               return action.payload;
            } else return [];
         case types["_41" /* CORE_LOAD_ALL_USER_FAILURE */]:
            return reducerUser_initialState;
         default:
            return state;
      }
   },
   userInfo: function userInfo() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerUser_requestState;
      var action = arguments[1];

      switch (action.type) {
         case types["_78" /* CORE_LOAD_USER_REQUEST */]:
            return reducerUser_requestState;
         case types["_79" /* CORE_LOAD_USER_SUCCESS */]:
            if (action.payload && reducerUser__typeof(action.payload) === 'object' && !Array.isArray(action.payload)) {
               return action.payload;
            } else return {};
         case types["_77" /* CORE_LOAD_USER_FAILURE */]:
            return reducerUser_initialStateObj;
         default:
            return state;
      }
   }
});
// CONCATENATED MODULE: ./src/reducers/reducerDevice.js
var reducerDevice__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var reducerDevice_initialState = [],
    reducerDevice_initialStateObj = {},
    reducerDevice_requestState = types["_128" /* REQUEST_STATE */];
/* harmony default export */ var reducerDevice = ({
  allDevice: function allDevice() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerDevice_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_15" /* CORE_LOAD_ALL_DEVICE_REQUEST */]:
        return reducerDevice_requestState;
      case types["_16" /* CORE_LOAD_ALL_DEVICE_SUCCESS */]:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload;
        } else return [];
      case types["_14" /* CORE_LOAD_ALL_DEVICE_FAILURE */]:
        return reducerDevice_initialState;
      default:
        return state;
    }
  },
  deviceInfo: function deviceInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerDevice_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_54" /* CORE_LOAD_DEVICE_REQUEST */]:
        return reducerDevice_requestState;
      case types["_55" /* CORE_LOAD_DEVICE_SUCCESS */]:
        if (action.payload && reducerDevice__typeof(action.payload) === 'object' && !Array.isArray(action.payload)) {
          return action.payload;
        } else return {};
      case types["_53" /* CORE_LOAD_DEVICE_FAILURE */]:
        return reducerDevice_initialStateObj;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/reducers/reducerLicensetype.js
var reducerLicensetype__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var reducerLicensetype_initialState = [],
    reducerLicensetype_initialStateObj = {},
    reducerLicensetype_requestState = 'request';
/* harmony default export */ var reducerLicensetype = ({
  allLicensetype: function allLicensetype() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerLicensetype_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_24" /* CORE_LOAD_ALL_LICENSETYPE_REQUEST */]:
        return reducerLicensetype_requestState;
      case types["_25" /* CORE_LOAD_ALL_LICENSETYPE_SUCCESS */]:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload;
        } else return [];
      case types["_23" /* CORE_LOAD_ALL_LICENSETYPE_FAILURE */]:
        return reducerLicensetype_initialState;
      default:
        return state;
    }
  },
  licensetypeInfo: function licensetypeInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerLicensetype_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_63" /* CORE_LOAD_LICENSETYPE_REQUEST */]:
        return reducerLicensetype_requestState;
      case types["_64" /* CORE_LOAD_LICENSETYPE_SUCCESS */]:
        if (action.payload && reducerLicensetype__typeof(action.payload) === 'object' && !Array.isArray(action.payload)) {
          return action.payload;
        } else return {};
      case types["_62" /* CORE_LOAD_LICENSETYPE_FAILURE */]:
        return reducerLicensetype_initialStateObj;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/reducers/reducerLicense.js
var reducerLicense__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var reducerLicense_initialState = [],
    reducerLicense_initialStateObj = {},
    reducerLicense_requestState = types["_128" /* REQUEST_STATE */];
/* harmony default export */ var reducerLicense = ({
  allLicense: function allLicense() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerLicense_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_33" /* CORE_LOAD_ALL_LICENSE_REQUEST */]:
        return reducerLicense_requestState;
      case types["_34" /* CORE_LOAD_ALL_LICENSE_SUCCESS */]:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload;
        } else return [];
      case types["_29" /* CORE_LOAD_ALL_LICENSE_FAILURE */]:
        return reducerLicense_initialState;
      default:
        return state;
    }
  },
  allLicenseDisplay: function allLicenseDisplay() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerLicense_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_27" /* CORE_LOAD_ALL_LICENSE_DISPLAY_REQUEST */]:
        return reducerLicense_requestState;
      case types["_28" /* CORE_LOAD_ALL_LICENSE_DISPLAY_SUCCESS */]:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload;
        } else return [];
      case types["_26" /* CORE_LOAD_ALL_LICENSE_DISPLAY_FAILURE */]:
        return reducerLicense_initialState;
      default:
        return state;
    }
  },
  allLicenseIOT: function allLicenseIOT() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerLicense_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_31" /* CORE_LOAD_ALL_LICENSE_IOT_REQUEST */]:
        return reducerLicense_requestState;
      case types["_32" /* CORE_LOAD_ALL_LICENSE_IOT_SUCCESS */]:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload;
        } else return [];
      case types["_30" /* CORE_LOAD_ALL_LICENSE_IOT_FAILURE */]:
        return reducerLicense_initialState;
      default:
        return state;
    }
  },
  licenseInfo: function licenseInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerLicense_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_66" /* CORE_LOAD_LICENSE_REQUEST */]:
        return reducerLicense_requestState;
      case types["_67" /* CORE_LOAD_LICENSE_SUCCESS */]:
        if (action.payload && reducerLicense__typeof(action.payload) === 'object' && !Array.isArray(action.payload)) {
          return action.payload;
        } else return {};
      case types["_65" /* CORE_LOAD_LICENSE_FAILURE */]:
        return reducerLicense_initialStateObj;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/reducers/reducerIOTAccessory.js
var reducerIOTAccessory__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var reducerIOTAccessory_initialState = [],
    reducerIOTAccessory_initialStateObj = {},
    reducerIOTAccessory_requestState = types["_128" /* REQUEST_STATE */];
/* harmony default export */ var reducerIOTAccessory = ({
  allIOTAccessory: function allIOTAccessory() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerIOTAccessory_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_18" /* CORE_LOAD_ALL_IOTACCESSORY_REQUEST */]:
        return reducerIOTAccessory_requestState;
      case types["_19" /* CORE_LOAD_ALL_IOTACCESSORY_SUCCESS */]:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload;
        } else return [];
      case types["_17" /* CORE_LOAD_ALL_IOTACCESSORY_FAILURE */]:
        return reducerIOTAccessory_initialState;
      default:
        return state;
    }
  },
  IOTAccessoryInfo: function IOTAccessoryInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerIOTAccessory_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_57" /* CORE_LOAD_IOTACCESSORY_REQUEST */]:
        return reducerIOTAccessory_requestState;
      case types["_58" /* CORE_LOAD_IOTACCESSORY_SUCCESS */]:
        if (action.payload && reducerIOTAccessory__typeof(action.payload) === 'object' && !Array.isArray(action.payload)) {
          return action.payload;
        } else return {};
      case types["_56" /* CORE_LOAD_IOTACCESSORY_FAILURE */]:
        return reducerIOTAccessory_initialStateObj;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/reducers/reducerIOTRoom.js
var reducerIOTRoom__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var reducerIOTRoom_initialState = [],
    reducerIOTRoom_initialStateObj = {},
    reducerIOTRoom_requestState = types["_128" /* REQUEST_STATE */];
/* harmony default export */ var reducerIOTRoom = ({
  allIOTRoom: function allIOTRoom() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerIOTRoom_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_21" /* CORE_LOAD_ALL_IOTROOM_REQUEST */]:
        return reducerIOTRoom_requestState;
      case types["_22" /* CORE_LOAD_ALL_IOTROOM_SUCCESS */]:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload;
        } else return [];
      case types["_20" /* CORE_LOAD_ALL_IOTROOM_FAILURE */]:
        return reducerIOTRoom_initialState;
      default:
        return state;
    }
  },
  IOTRoomInfo: function IOTRoomInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerIOTRoom_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_60" /* CORE_LOAD_IOTROOM_REQUEST */]:
        return reducerIOTRoom_requestState;
      case types["_61" /* CORE_LOAD_IOTROOM_SUCCESS */]:
        if (action.payload && reducerIOTRoom__typeof(action.payload) === 'object' && !Array.isArray(action.payload)) {
          return action.payload;
        } else return {};
      case types["_59" /* CORE_LOAD_IOTROOM_FAILURE */]:
        return reducerIOTRoom_initialStateObj;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/reducers.js

















/* harmony default export */ var reducers = (Object(es["c" /* combineReducers */])({
    form: redux_form_es["a" /* reducer */],
    notifications: Object(lib["reducer"])(),
    ui: reducer,
    deleteState: reducerDeleteState.deleteState,

    allCustomer: reducerCustomer.allCustomer,
    customerInfo: reducerCustomer.customerInfo,

    allContact: reducerContact.allContact,
    searchContact: reducerContact.searchContact,
    contactInfo: reducerContact.contactInfo,

    allProfile: reducerProfile.allProfile,
    profileInfo: reducerProfile.profileInfo,

    allProduct: reducerProduct.allProduct,
    productInfo: reducerProduct.productInfo,
    versionProduct: reducerProduct.versionProduct,

    allVersion: reducerVersion.allVersion,
    versionInfo: reducerVersion.versionInfo,

    allUser: reducerUser.allUser,
    userInfo: reducerUser.userInfo,

    allDevice: reducerDevice.allDevice,
    deviceInfo: reducerDevice.deviceInfo,

    allLicensetype: reducerLicensetype.allLicensetype,
    licensetypeInfo: reducerLicensetype.licensetypeInfo,

    allLicense: reducerLicense.allLicense,
    allLicenseDisplay: reducerLicense.allLicenseDisplay,
    allLicenseIOT: reducerLicense.allLicenseIOT,
    licenseInfo: reducerLicense.licenseInfo,

    allIOTAccessory: reducerIOTAccessory.allIOTAccessory,
    IOTAccessoryInfo: reducerIOTAccessory.IOTAccessoryInfo,

    allIOTRoom: reducerIOTRoom.allIOTRoom,
    IOTRoomInfo: reducerIOTRoom.IOTRoomInfo
}));
// CONCATENATED MODULE: ./src/store/configureStore.prod.js





/* harmony default export */ var configureStore_prod = __webpack_exports__["default"] = (function (initialState) {
    var middlewares = [src_middlewares["c" /* checkToken */], src_middlewares["d" /* setToken */], src_middlewares["b" /* api */], redux_thunk_es["a" /* default */]];

    var store = Object(es["d" /* createStore */])(reducers, initialState, es["a" /* applyMiddleware */].apply(undefined, middlewares));

    return store;
});

/***/ })

},[228]);


// WEBPACK FOOTER //
// app.4f2ea078d3b6a40a11ca.js